/**
 * ConfidenceBadge Component
 * Visual representation of AI confidence score (0-1)
 */

interface ConfidenceBadgeProps {
  confidence: number;
}

export default function ConfidenceBadge({ confidence }: ConfidenceBadgeProps) {
  const percentage = Math.round(confidence * 100);
  
  const getConfidenceLevel = () => {
    if (confidence >= 0.8) return { level: 'High', class: 'confidence-high' };
    if (confidence >= 0.5) return { level: 'Medium', class: 'confidence-medium' };
    return { level: 'Low', class: 'confidence-low' };
  };

  const { level, class: confidenceClass } = getConfidenceLevel();

  return (
    <div className="inline-flex flex-col items-start">
      <span className={`${confidenceClass} text-white px-4 py-2 rounded-full text-sm font-bold shadow-md`}>
        {level} Confidence: {percentage}%
      </span>
      
      {/* Progress Bar */}
      <div className="w-full mt-2 bg-gray-200 rounded-full h-2 overflow-hidden">
        <div
          className={`h-full ${confidenceClass} transition-all duration-500`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}

